import { Button, Stack } from '@mui/material';
import React, { useCallback, useContext } from 'react';
import { FORM_WIDGET_COMPONENTS, METADATA_NAMES } from '../../../../form/formConstants';
import { FormContext, FormContextType } from '../../../../form/FormContext';
import FormWidget from '../../../../form/FormWidget';
import I18n from '../../../../i18n/I18n';
import type { ShareSettingsFormState } from '../../../types';
import { useInternalShareSettings } from '../../hooks/useInternalShareSettings';
import { mergeDepartmentsToAddIntoSharedWithDepartments } from '../../utils';

export default function ShareDepartmentSelectionFormField() {
    const { state, handleChange } = useContext<FormContextType<ShareSettingsFormState>>(FormContext);
    const { shareSettings, updateShareSettingsState } = useInternalShareSettings();

    const handleAdd = () => {
        updateShareSettingsState({
            sharedWithDepartments: mergeDepartmentsToAddIntoSharedWithDepartments(
                shareSettings.sharedWithDepartments,
                state.departmentsToAddToSharedWith,
                state.defaultAction
            )
        });
        handleChange('departmentsToAddToSharedWith', []);
    };

    const handleCancel = useCallback(() => {
        handleChange('departmentsToAddToSharedWith', []);
    }, [handleChange]);

    return (
        <>
            <FormWidget
                component={FORM_WIDGET_COMPONENTS.metadataAutocomplete}
                metadataName={METADATA_NAMES.department}
                name="departmentsToAddToSharedWith"
                label={<I18n token="common.search.for.departments" />}
                multiple
            />
            {state.departmentsToAddToSharedWith.length > 0 && (
                <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 1, width: '100%' }}>
                    <Button variant="text" onClick={handleCancel}>
                        <I18n token="dialog.cancel" />
                    </Button>
                    <Button variant="outlined" onClick={handleAdd}>
                        <I18n token="button.add" />
                    </Button>
                </Stack>
            )}
        </>
    );
}
